import { render, staticRenderFns } from "./H5PUpload.vue?vue&type=template&id=8ed94956&"
import script from "./H5PUpload.vue?vue&type=script&lang=js&"
export * from "./H5PUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports